import { decimals, field, hidden, print } from "@/utils/models/decorator-field";
import { model } from "@/utils/models/decorator-model";
import { printLocalDate } from "@/utils/pretty-print";
import { LedgerAccount } from "../ledger-account";

@model("Bookkeeping")
export class Bookkeeping {
	@field("number")
	@hidden()
	public ID:number = 0;

	@field("string")
	Type:string = "";

	@field("string")
	LedgerGroup:string = "";

	@field("string")
	LedgerCode:string = "";

	@field("string")
	Description:string = "";

	@field("number")
	@decimals(2)
	Debet:number = 0;

	@field("number")
	@decimals(2)
	Credit:number = 0;

	@field("number")
	@decimals(2)
	Active:number = 0;

	@field("number")
	@decimals(2)
	Passive:number = 0;

	@field("string")
	Fnr:string = "";

	@field("date")
	@print(printLocalDate)
	Date:Date = new Date();

	@field("string")
	ContactName:string = "";

	@field("string")
	Info:string = "";

	@field("boolean")
	@hidden()
	IsResultRow:boolean = false;

	@field("number")
	BookYear:number = 0;

	@field("has-one", "LedgerAccount")
	LedgerAccount:LedgerAccount | null = null;

	public constructor(data?:any){
		if (!data) return;
		this.ID = data.ID;
		this.Type = data.Type;
		this.LedgerGroup = data.LedgerGroup;
		this.LedgerCode = data.LedgerCode;
		this.Description = data.Description;
		this.Debet = data.Debet;
		this.Credit = data.Credit;
		this.Active = data.Active;
		this.Passive = data.Passive;
		this.Fnr = data.Fnr;
		this.Date = new Date(data.Date);
		this.ContactName = data.ContactName;
		this.Info = data.Info;
		this.IsResultRow = data.IsResultRow;
		this.BookYear = data.BookYear;
		if (data.LedgerAccount) {
			this.LedgerAccount = new LedgerAccount(data.LedgerAccount);
		}
	}
}